import { Button } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import * as api from "../../utils/api";


const CodPayment = ({ SelectedAddress, isPickup, selectedPaymentMethod }) => {
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);

  const checkoutData = JSON.parse(localStorage.getItem("checkoutData"));

  // Function to place the order
  const placeOrder = async () => {
    if (!isPickup && !SelectedAddress) {
      toast.error("Please select a delivery address");
    } else if (!selectedPaymentMethod) {
      toast.error("Please select a payment method");
    } else {
      await processOrderPlacement();
    }
  };

  const processOrderPlacement = async () => {
    try {
      if (!checkoutData.cartItems || checkoutData.cartItems.length === 0) {
        throw new Error("No items in the cart.");
      }


      const cartItems = checkoutData.cartItems.map(item => {
        const {
          id,
          title,
          image,
          sell_price: price,
          qty: selectedQty,
          vendor_id,
        } = item;

        if (!id || !price || !title) {
          throw new Error(`Missing essential fields for item: ${title || id}`);
        }

        return {
          selected_qty: selectedQty,
          price: price,
          product: {
            id: id,
            name: title,
            barcode: "",
            price: price,
            discount_price: price,
            vendor_id: vendor_id,
            selected_qty: selectedQty,
            token: JSON.parse(localStorage.getItem("token"))
          },
          options: [],
          options_ids: null,
          options_flatten: ""
        };
      });


      const payload = {
        tip: "",
        note: "",
        coupon_code: checkoutData.coupon ? checkoutData.coupon.code : "",
        pickup_date: checkoutData.deliverySlotDate || "",
        pickup_time: checkoutData.deliverySlotTime || "",
        products: cartItems,
        vendor_id: checkoutData.cartItems?.[0]?.vendor_id,
        delivery_address_id: SelectedAddress?.id,
        payment_method_id: selectedPaymentMethod?.id || 1,
        sub_total: checkoutData.subTotal,
        discount: checkoutData.discount,
        delivery_fee: checkoutData.deliveryFee ?? 0,
        tax: checkoutData.tax ?? 0,
        fees: checkoutData.fees || [],
        total: checkoutData.grandTotal,
        token: JSON.parse(localStorage.getItem("token"))
      };

      setLoad(true);
      const response = await api.placeOrder(payload);
      if (response.code) {
        // localStorage.setItem("order_id", response.code);
        setLoad(false);
        localStorage.removeItem('checkoutData'); 
        localStorage.removeItem('cart'); 
        localStorage.removeItem('vendor_type_id'); 

        navigate("/confirmed");
      } else {
        toast.error("Failed to place order.");
      }
    } catch (error) {
      console.error("Order placement error:", error);
      setLoad(false);
      toast.error(`An error occurred while placing the order: ${error.message}`);
    }
  };


  return (
    <div>
      <Button variant="outlined" onClick={placeOrder} color="error">
        {!load ? "Place Order" : "Please wait..."}
      </Button>
    </div>
  );
};

export default CodPayment;
